(() => {
  if (window.SlabHubRandomFrame) return;
  const FILES = 'https://cdn.shopify.com/s/files/1/0929/4757/9222/files/';
  const small = matchMedia('(max-width: 749px)').matches;
  function bind(section) {
    if (section.dataset.randomBound) return;
    let models = window.SlabHubHomeModels || [];
    /* solo prodotti pubblicati */
    const active = window.SlabHubActiveHandles;
    if (Array.isArray(active) && active.length) models = models.filter(m => active.includes(m.handle));
    /* cornici "in hype": la prima che si vede quando si apre il sito (Claude, 12 ottobre, scelta di Gabriele) */
    const hypeHandles = (section.dataset.hype || '').split(',').map(h => h.trim()).filter(Boolean);
    const hype = models.filter(m => hypeHandles.includes(m.handle));
    /* per il tasto "un'altra cornice": tutte, tranne quelle gia' in "Prodotti in evidenza" */
    const exclude = (section.dataset.exclude || '').split(',').filter(Boolean);
    const pool = models.filter(m => !exclude.includes(m.handle));
    if (pool.length) models = pool;
    if (!models.length && !hype.length) return;
    section.dataset.randomBound = 'true';
    const wrapper = section.querySelector('[data-slab-card-3d]');
    const viewer = section.querySelector('model-viewer');
    const poster = section.querySelector('[data-slab-random-poster]');
    const hint = section.querySelector('[data-slab-random-hint]');
    const next = section.querySelector('[data-slab-random-next]');
    const link = section.querySelector('[data-slab-random-link]');
    const title = section.querySelector('[data-slab-random-title]');
    /* su telefono il modello leggero (catalog), su computer quello completo */
    if (small) delete viewer.dataset.sourceQuality;
    let current, touched = false;
    function choose(first) {
      let previous = current;
      if (!previous) { try { previous = sessionStorage.getItem('slabhub-last-home-frame'); } catch (_) {} }
      const source = first && hype.length ? hype : (models.length ? models : hype);
      const choices = source.filter(model => model.handle !== previous);
      const list = choices.length ? choices : source;
      const model = list[Math.floor(Math.random() * list.length)];
      current = model.handle;
      try { sessionStorage.setItem('slabhub-last-home-frame', current); } catch (_) {}
      title.textContent = model.title;
      link.href = model.href;
      viewer.alt = model.title;
      next.disabled = true;
      poster.hidden = false;
      poster.alt = model.title;
      poster.src = FILES + 'sh-' + model.handle + '-1-frontale.webp?width=1200';
      window.SlabHubCard3D.changeModel(wrapper, model.src, model.handle);
    }
    poster.addEventListener('error', () => { poster.hidden = true; });
    viewer.addEventListener('load', () => {
      next.disabled = false;
      if (!touched) section.classList.add('is-hinting');
    });
    viewer.addEventListener('error', () => { next.disabled = false; });
    /* l'indicazione sparisce al primo tocco sulla cornice o dopo qualche secondo */
    const stage = section.querySelector('.slab-home-random__stage');
    stage.addEventListener('pointerdown', () => { touched = true; section.classList.remove('is-hinting'); }, { passive: true });
    viewer.addEventListener('load', () => { setTimeout(() => section.classList.remove('is-hinting'), 7000); });
    next.addEventListener('click', () => { touched = true; section.classList.remove('is-hinting'); choose(false); });
    choose(true);
  }
  function scan(root = document) { root.querySelectorAll('[data-slab-home-random]').forEach(bind); }
  window.SlabHubRandomFrame = { scan };
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
